function e(o) {
  const t = o || typeof window < "u" && window;
  return !!(t && (/Chromatic/.test(t.navigator.userAgent) || /chromatic=true/.test(t.location.href)));
}
export {
  e as default
};
//# sourceMappingURL=isChromatic-5i32AXac.js.map
